var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoricAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.97 22.75C7.24997 22.75 4.21997 19.72 4.21997 16V10C4.21997 5.73 7.69997 2.25 11.97 2.25C16.24 2.25 19.72 5.73 19.72 10V15.5C19.72 17.84 17.81 19.75 15.47 19.75C13.13 19.75 11.22 17.84 11.22 15.5V12C11.22 11.59 11.56 11.25 11.97 11.25C12.38 11.25 12.72 11.59 12.72 12V15.5C12.72 17.02 13.95 18.25 15.47 18.25C16.99 18.25 18.22 17.02 18.22 15.5V10C18.22 6.55 15.42 3.75 11.97 3.75C8.51997 3.75 5.71997 6.55 5.71997 10V16C5.71997 18.89 8.06997 21.25 10.97 21.25C11.38 21.25 11.72 21.59 11.72 22C11.72 22.41 11.39 22.75 10.97 22.75Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoricAttach);
export default __webpack_public_path__ + "static/media/HistoricAttach.77e9ba58.svg";
export { ForwardRef as ReactComponent };